var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("el-row", { staticClass: "filter" }, [
        _c(
          "div",
          { staticStyle: { width: "80%", margin: "20px auto" } },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.form,
                  rules: _vm.rules,
                  "label-width": "220px"
                }
              },
              [
                _c(
                  "el-card",
                  {
                    staticClass: "box-card",
                    class: {
                      "border-green": _vm.isAvailableStore === true,
                      "border-red": _vm.isAvailableStore === false
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "爆版手机账号" } },
                      [
                        _c("el-input", {
                          scopedSlots: _vm._u([
                            {
                              key: "append",
                              fn: function() {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { padding: "0 8px" },
                                      attrs: { type: "text" },
                                      on: { click: _vm.getShopList }
                                    },
                                    [_vm._v("获取店铺列表")]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ]),
                          model: {
                            value: _vm.form.baobmobile,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "baobmobile", $$v)
                            },
                            expression: "form.baobmobile"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "爆版店铺", prop: "shopId" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择爆版店铺" },
                            on: { change: _vm.verifyShopInfo },
                            model: {
                              value: _vm.form.shopId,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shopId", $$v)
                              },
                              expression: "form.shopId"
                            }
                          },
                          _vm._l(_vm.shop_list, function(item) {
                            return _c("el-option", {
                              key: item.shopId,
                              attrs: {
                                label: item.shopName,
                                value: item.shopId
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "是否自助上款", prop: "is_self" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择是否自助上款" },
                            model: {
                              value: _vm.form.is_self,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "is_self", $$v)
                              },
                              expression: "form.is_self"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "是", value: "1" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "否", value: "0" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "自助上款全类目", prop: "is_all_style" }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择自助上款全类目" },
                            model: {
                              value: _vm.form.is_all_style,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "is_all_style", $$v)
                              },
                              expression: "form.is_all_style"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "是", value: "1" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "否", value: "0" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "商家名称" } },
                  [
                    _c("el-input", {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.supply_name,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_name", $$v)
                        },
                        expression: "form.supply_name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "商家性质",
                      prop: "supply_character",
                      required: ""
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择商家性质" },
                        model: {
                          value: _vm.form.supply_character,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "supply_character", $$v)
                          },
                          expression: "form.supply_character"
                        }
                      },
                      _vm._l(_vm.supply_character_options, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否可刷单", prop: "is_scal" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否可刷单" },
                        model: {
                          value: _vm.form.is_scal,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_scal", $$v)
                          },
                          expression: "form.is_scal"
                        }
                      },
                      _vm._l(_vm.is_scal_options, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "商家状态", prop: "supply_status" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "商家状态" },
                        on: { change: _vm.changeStatus },
                        model: {
                          value: _vm.form.supply_status,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "supply_status", $$v)
                          },
                          expression: "form.supply_status"
                        }
                      },
                      _vm._l(_vm.supply_status, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "合并账单日期", prop: "bill_merger_date" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: { multiple: "", placeholder: "合并账单日期" },
                        model: {
                          value: _vm.form.bill_merger_date,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bill_merger_date", $$v)
                          },
                          expression: "form.bill_merger_date"
                        }
                      },
                      _vm._l(_vm.Date_list, function(item) {
                        return _c("el-option", {
                          key: item,
                          attrs: { label: item, value: item }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        "\n            填写后，商家前置仓账单会根据每月已填写的日期进行自动合并。\n          "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "活动费扣取方式",
                      prop: "activity_fee_buckle"
                    }
                  },
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: "1" },
                        model: {
                          value: _vm.form.activity_fee_buckle,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "activity_fee_buckle", $$v)
                          },
                          expression: "form.activity_fee_buckle"
                        }
                      },
                      [_vm._v("\n            账单方式\n          ")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "activity-free-buckle-span" }, [
                      _vm._v("选择此结算方式，商家活动费在账单中扣取。")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _vm.form.activity_fee_buckle === "1"
                          ? _c("el-switch", {
                              attrs: {
                                "active-value": "1",
                                "inactive-value": "2"
                              },
                              model: {
                                value: _vm.form.open_qz_auto_buckle,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "open_qz_auto_buckle", $$v)
                                },
                                expression: "form.open_qz_auto_buckle"
                              }
                            })
                          : _vm._e(),
                        _vm._v("\n            前置仓账单扣取\n            "),
                        _c("span", { staticClass: "open-qz-span" }, [
                          _vm._v(
                            "\n              *若开启，则活动费抵扣可在前置仓代采订单中扣取，否则前置仓代采订单不自动扣取活动费。\n            "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { prop: "is_return_profit" } },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _vm._v("\n            折扣让利（佣金）\n            "),
                        _c("el-tooltip", { attrs: { effect: "light" } }, [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v(
                                "\n                商家签订折扣让利协议后，按月销量达标的商品由商家让利给一手平台。\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", { staticClass: "el-icon-question" })
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.form.is_return_profit,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_return_profit", $$v)
                          },
                          expression: "form.is_return_profit"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: "1" } }, [
                          _vm._v(" 参与 ")
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: "2" } }, [
                          _vm._v(" 不参与 ")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.form.is_return_profit === _vm.constantMap.isJoinProfit
                  ? [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "让利账单生成周期 ",
                            prop: "period_profit",
                            rules: _vm.commonRules.ruleChange
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { filterable: "", placeholder: "请选择" },
                              model: {
                                value: _vm.form.period_profit,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "period_profit", $$v)
                                },
                                expression: "form.period_profit"
                              }
                            },
                            _vm._l(_vm.periodProfitStatus, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n              如商家当前已经参与此协议，在切换账期模式后，本月仍保持旧的账期规则，直到下个月1号才会按新设置生效。若商家没参加过协议，或协议关闭已经超过一个月了，则马上生效。\n            "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "生效时间",
                            prop: "return_profit_month",
                            rules: _vm.commonRules.ruleChange
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "picker-options": _vm.constantMap.pickerOptions,
                              type: "date",
                              size: "small",
                              "value-format": "yyyy-MM-dd",
                              placeholder: "选择生效时间"
                            },
                            model: {
                              value: _vm.form.return_profit_month,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "return_profit_month", $$v)
                              },
                              expression: "form.return_profit_month"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticStyle: { color: "gray" } }, [
                            _vm._v(
                              "\n              在生效日期起代采开单且发货出库的商品将进行让利销量统计，历史数据请在让利销量汇总表补生成\n            "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "结算方式",
                            prop: "clearing_form",
                            rules: _vm.commonRules.ruleChange
                          }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.clearing_form,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "clearing_form", $$v)
                                },
                                expression: "form.clearing_form"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v(" 代采单抵扣 ")
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "2" } }, [
                                _vm._v(" 账单支付 ")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商品要求",
                            prop: "reserve_price",
                            rules: _vm.commonRules.ruleBlur
                          }
                        },
                        [
                          _c(
                            "YsInput",
                            {
                              staticStyle: { "min-width": "50%" },
                              attrs: { pattern: "money", size: "small" },
                              model: {
                                value: _vm.form.reserve_price,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "reserve_price", $$v)
                                },
                                expression: "form.reserve_price"
                              }
                            },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "prepend" }, slot: "prepend" },
                                [_vm._v(" 非特价、且商家价> ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { attrs: { slot: "append" }, slot: "append" },
                                [_vm._v("元/件")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "让利单价设置",
                            prop: "return_profit_rule",
                            rules: _vm.commonRules.ruleChangeArray
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.handleReturnProfitRuleAdd }
                            },
                            [_vm._v("\n              添加设置行\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              attrs: {
                                data: _vm.form.return_profit_rule,
                                border: "",
                                size: "mini"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "序号",
                                  width: "80"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var $index = ref.$index
                                        return [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s($index + 1) +
                                              "\n                "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3878754635
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "num",
                                  align: "center",
                                  label: "月度销售件数达标门槛（按商品货号）"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        var $index = ref.$index
                                        return _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "return_profit_rule." +
                                                $index +
                                                ".num",
                                              rules: _vm.commonRules.ruleBlur
                                            }
                                          },
                                          [
                                            _c(
                                              "YsInput",
                                              {
                                                attrs: {
                                                  pattern: "positiveInt",
                                                  size: "small"
                                                },
                                                model: {
                                                  value: row.num,
                                                  callback: function($$v) {
                                                    _vm.$set(row, "num", $$v)
                                                  },
                                                  expression: "row.num"
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: { slot: "prepend" },
                                                    slot: "prepend"
                                                  },
                                                  [_vm._v("达到")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: { slot: "append" },
                                                    slot: "append"
                                                  },
                                                  [_vm._v("件及以上时")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  259575427
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "price",
                                  align: "center",
                                  label: "让利单价"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        var $index = ref.$index
                                        return _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "return_profit_rule." +
                                                $index +
                                                ".price",
                                              rules: _vm.rulePrice
                                            }
                                          },
                                          [
                                            _c(
                                              "YsInput",
                                              {
                                                attrs: {
                                                  pattern: "money",
                                                  size: "small"
                                                },
                                                model: {
                                                  value: row.price,
                                                  callback: function($$v) {
                                                    _vm.$set(row, "price", $$v)
                                                  },
                                                  expression: "row.price"
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: { slot: "append" },
                                                    slot: "append"
                                                  },
                                                  [_vm._v("元/件")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  615513313
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "actions",
                                  align: "center",
                                  label: "操作",
                                  width: "100"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var $index = ref.$index
                                        return _c(
                                          "el-form-item",
                                          {},
                                          [
                                            _vm.form.return_profit_rule.length >
                                            1
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "danger",
                                                      size: "small"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.handleReturnProfitRuleDel(
                                                          $index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    删除\n                  "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4167733068
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "城市", prop: "city" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "城市" },
                        on: { change: _vm.handleSelectCity },
                        model: {
                          value: _vm.form.city,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "city", $$v)
                          },
                          expression: "form.city"
                        }
                      },
                      _vm._l(_vm.citys, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "市场（地理位置）", prop: "father_market" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "市场" },
                        on: { change: _vm.setChild },
                        model: {
                          value: _vm.form.father_market,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "father_market", $$v)
                          },
                          expression: "form.father_market"
                        }
                      },
                      _vm._l(_vm.marketList, function(item) {
                        return _c("el-option", {
                          key: item.key,
                          attrs: { label: item.label, value: item.key }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "子市场（地理位置）", prop: "market_id" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "子市场" },
                        model: {
                          value: _vm.form.market_id,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "market_id", $$v)
                          },
                          expression: "form.market_id"
                        }
                      },
                      _vm._l(_vm.subMarketList, function(item) {
                        return _c("el-option", {
                          key: item.key,
                          attrs: { label: item.label, value: item.key }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { prop: "attributable_market_id" } },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _vm._v("\n            业绩归属市场\n            "),
                        _c("el-tooltip", { attrs: { effect: "light" } }, [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v(
                                "\n                用于统计公司内部各市场部门的业绩销售情况\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", { staticClass: "el-icon-question" })
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "业绩归属市场" },
                        on: {
                          change: function($event) {
                            return _vm.handleSetAttributableSubMarket(
                              _vm.form.attributable_market_id
                            )
                          }
                        },
                        model: {
                          value: _vm.form.attributable_market_id,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "attributable_market_id", $$v)
                          },
                          expression: "form.attributable_market_id"
                        }
                      },
                      _vm._l(_vm.performanceMarketList, function(item) {
                        return _c("el-option", {
                          key: item.attributable_market_id,
                          attrs: {
                            label: item.attributable_market_name,
                            value: item.attributable_market_id
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "业绩归属细分市场",
                      prop: "attributable_market_sub_id"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: "业绩归属细分市场"
                        },
                        model: {
                          value: _vm.form.attributable_market_sub_id,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "attributable_market_sub_id",
                              $$v
                            )
                          },
                          expression: "form.attributable_market_sub_id"
                        }
                      },
                      _vm._l(_vm.performanceSubMarketList, function(item) {
                        return _c("el-option", {
                          key: item.sub_id,
                          attrs: { label: item.sub_name, value: item.sub_id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "楼层", prop: "supply_floor" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "楼层" },
                        on: { change: _vm.genSupplyName },
                        model: {
                          value: _vm.form.supply_floor,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "supply_floor", $$v)
                          },
                          expression: "form.supply_floor"
                        }
                      },
                      _vm._l(_vm.resData.floor, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "区域/街", prop: "supply_area_id" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "区域/街" },
                        on: { change: _vm.genSupplyName },
                        model: {
                          value: _vm.form.supply_area_id,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "supply_area_id", $$v)
                          },
                          expression: "form.supply_area_id"
                        }
                      },
                      _vm._l(_vm.resData.supply_area, function(item) {
                        return _c("el-option", {
                          key: item.supply_area_id,
                          attrs: {
                            label: item.supply_area,
                            value: item.supply_area_id
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "档口号", prop: "supplier_num" } },
                  [
                    _c("el-autocomplete", {
                      staticClass: "inline-input",
                      attrs: {
                        "fetch-suggestions": _vm.querySearch,
                        placeholder: "请输入档口号"
                      },
                      on: { select: _vm.handleSelect, blur: _vm.genSupplyName },
                      model: {
                        value: _vm.form.supplier_num,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supplier_num", $$v)
                        },
                        expression: "form.supplier_num"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "一手商城档口名" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder:
                          "显示于档口形象图上面的昵称（最多10个中文字）"
                      },
                      model: {
                        value: _vm.form.supply_nickname,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_nickname", $$v)
                        },
                        expression: "form.supply_nickname"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "品牌", prop: "brand" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "50%", float: "left" },
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.brand,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "brand", $$v)
                        },
                        expression: "form.brand"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.brandVisible = true
                          }
                        }
                      },
                      [_vm._v(" 编辑 ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "代采组", prop: "pgid" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "代采组" },
                        on: { change: _vm.getMemberOption },
                        model: {
                          value: _vm.form.pgid,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "pgid", $$v)
                          },
                          expression: "form.pgid"
                        }
                      },
                      _vm._l(_vm.resData.pg_list, function(item) {
                        return _c("el-option", {
                          key: item.pgid,
                          attrs: { label: item.pgname, value: item.pgid }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "代采员", prop: "pg_member_id" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "代采员" },
                        model: {
                          value: _vm.form.pg_member_id,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "pg_member_id", $$v)
                          },
                          expression: "form.pg_member_id"
                        }
                      },
                      [
                        _c("el-option", {
                          key: "0",
                          attrs: { label: "全部", value: "0" }
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.memberOption, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "次品组", prop: "dgid" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "次品组" },
                        on: { change: _vm.getDefectiveGroupMember },
                        model: {
                          value: _vm.form.dgid,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "dgid", $$v)
                          },
                          expression: "form.dgid"
                        }
                      },
                      [
                        _c("el-option", {
                          key: "0",
                          attrs: { value: "0", label: "请选择" }
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.defectiveGroupOption, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "次品员", prop: "dg_member_id" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "次品员" },
                        on: { change: _vm.handleChangeDgMemberId },
                        model: {
                          value: _vm.form.dg_member_id,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "dg_member_id", $$v)
                          },
                          expression: "form.dg_member_id"
                        }
                      },
                      [
                        _c("el-option", {
                          key: "0",
                          attrs: { value: "0", label: "请选择" }
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.defectiveGroupMemberOption, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "售后退供员", prop: "refund_member_id" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "售后退供员" },
                        model: {
                          value: _vm.form.refund_member_id,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "refund_member_id", $$v)
                          },
                          expression: "form.refund_member_id"
                        }
                      },
                      [
                        _c("el-option", {
                          key: "0",
                          attrs: { value: "0", label: "请选择" }
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.refundMemberOption, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "买手组", prop: "pg_id" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "买手组" },
                        on: { change: _vm.getPickerGroupMemberOption },
                        model: {
                          value: _vm.form.pg_id,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "pg_id", $$v)
                          },
                          expression: "form.pg_id"
                        }
                      },
                      _vm._l(_vm.resData.pickers, function(item) {
                        return _c("el-option", {
                          key: item.pg_id,
                          attrs: { label: item.pg_name, value: item.pg_id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "买手",
                      prop: "supply_picker_group_member_id"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "买手" },
                        model: {
                          value: _vm.form.supply_picker_group_member_id,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "supply_picker_group_member_id",
                              $$v
                            )
                          },
                          expression: "form.supply_picker_group_member_id"
                        }
                      },
                      [
                        _c("el-option", {
                          key: "0",
                          attrs: { value: "0", label: "无" }
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.PickerGroupMemberOption, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "商家运营跟进人", prop: "follower" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: "商家运营跟进人"
                        },
                        model: {
                          value: _vm.form.follower_admin_id,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "follower_admin_id", $$v)
                          },
                          expression: "form.follower_admin_id"
                        }
                      },
                      _vm._l(_vm.resData.follower, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: {
                            disabled: item.admin_status == 0,
                            label: item.label,
                            value: item.value
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "商家开发人", prop: "supply_developer" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "商家开发人" },
                        model: {
                          value: _vm.form.supply_developer_admin,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "supply_developer_admin", $$v)
                          },
                          expression: "form.supply_developer_admin"
                        }
                      },
                      _vm._l(_vm.resData.supply_developer, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "前置仓跟进人", prop: "pre_storage_admin" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "前置仓跟进人" },
                        model: {
                          value: _vm.form.pre_storage_admin,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "pre_storage_admin", $$v)
                          },
                          expression: "form.pre_storage_admin"
                        }
                      },
                      _vm._l(_vm.resData.pre_storage_admin_list, function(
                        item
                      ) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "联系方式" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "45%", float: "left" },
                      attrs: { placeholder: "手机" },
                      model: {
                        value: _vm.form.supply_mobile_phone,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_mobile_phone", $$v)
                        },
                        expression: "form.supply_mobile_phone"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-input", {
                      staticStyle: { width: "45%", float: "left" },
                      attrs: { placeholder: "微信" },
                      model: {
                        value: _vm.form.supply_wechat,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_wechat", $$v)
                        },
                        expression: "form.supply_wechat"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "商品默认活跃值" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "45%" },
                      attrs: { placeholder: "商家新建商品默认活跃值" },
                      model: {
                        value: _vm.form.supply_action_value,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_action_value", $$v)
                        },
                        expression: "form.supply_action_value"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "排单锁定天数", prop: "limit_day" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { type: "number" },
                      scopedSlots: _vm._u([
                        {
                          key: "append",
                          fn: function() {
                            return [_vm._v(" 天 ")]
                          },
                          proxy: true
                        }
                      ]),
                      model: {
                        value: _vm.form.limit_day,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "limit_day", $$v)
                        },
                        expression: "form.limit_day"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "超时断计划", prop: "plan_time_out_days" }
                  },
                  [
                    _c("ys-input", {
                      staticStyle: { width: "200px" },
                      attrs: { pattern: "positiveInt", min: "1", max: "999" },
                      scopedSlots: _vm._u([
                        {
                          key: "append",
                          fn: function() {
                            return [_vm._v(" 天 ")]
                          },
                          proxy: true
                        }
                      ]),
                      model: {
                        value: _vm.form.plan_time_out_days,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "plan_time_out_days", $$v)
                        },
                        expression: "form.plan_time_out_days"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n            超过（大于）设定天数未开单且无客需的\n            "
                      ),
                      _c("span", { staticStyle: { color: "#f00" } }, [
                        _vm._v("系统计划")
                      ]),
                      _vm._v("\n            及\n            "),
                      _c("span", { staticStyle: { color: "#f00" } }, [
                        _vm._v("重采计划")
                      ]),
                      _vm._v(
                        "\n            （数量不足来源）以及\n            "
                      ),
                      _c("span", { staticStyle: { color: "#f00" } }, [
                        _vm._v("虚拟库存采购计划")
                      ]),
                      _vm._v("\n            自动断待开单。\n          ")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.form.payees, function(payee, index) {
                  return _c(
                    "el-form-item",
                    {
                      key: payee.key,
                      attrs: {
                        label: "收款人信息" + (index + 1),
                        prop: "payees." + index + ".value"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "20%", float: "left" },
                        attrs: { placeholder: "姓名" },
                        model: {
                          value: payee.payee_name,
                          callback: function($$v) {
                            _vm.$set(payee, "payee_name", $$v)
                          },
                          expression: "payee.payee_name"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "20%", float: "left" },
                          attrs: { filterable: "", placeholder: "收款银行" },
                          on: { change: _vm.setBank },
                          model: {
                            value: payee.payee_bank,
                            callback: function($$v) {
                              _vm.$set(payee, "payee_bank", $$v)
                            },
                            expression: "payee.payee_bank"
                          }
                        },
                        _vm._l(_vm.resData.banks, function(item) {
                          return _c("el-option", {
                            key: item,
                            attrs: { label: item, value: item }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "20%", float: "left" },
                          attrs: {
                            filterable: "",
                            remote: "",
                            "remote-method": _vm.setCnap,
                            placeholder: "所屬支行(至少输入四位才可以筛选)"
                          },
                          model: {
                            value: payee.cnap,
                            callback: function($$v) {
                              _vm.$set(payee, "cnap", $$v)
                            },
                            expression: "payee.cnap"
                          }
                        },
                        [
                          _c("el-option", { attrs: { value: "" } }, [
                            _vm._v(" 请选择 ")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.cnaps, function(item) {
                            return _c("el-option", {
                              key: item.cnap,
                              attrs: { label: item.cnap_name, value: item.cnap }
                            })
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("el-input", {
                        staticStyle: { width: "20%", float: "left" },
                        attrs: { placeholder: "账号" },
                        model: {
                          value: payee.payee_bank_account,
                          callback: function($$v) {
                            _vm.$set(payee, "payee_bank_account", $$v)
                          },
                          expression: "payee.payee_bank_account"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: index },
                          model: {
                            value: _vm.form.is_default,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "is_default", $$v)
                            },
                            expression: "form.is_default"
                          }
                        },
                        [_vm._v("\n            默认收款账号\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.removePayee(payee)
                            }
                          }
                        },
                        [_vm._v(" 删除 ")]
                      )
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c("el-button", { on: { click: _vm.addPayee } }, [
                  _vm._v(" 增加收款人 ")
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "备注", prop: "remark" } },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea" },
                      model: {
                        value: _vm.form.remark,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "remark", $$v)
                        },
                        expression: "form.remark"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否KA", prop: "is_ka" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否KA" },
                        model: {
                          value: _vm.form.is_ka,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_ka", $$v)
                          },
                          expression: "form.is_ka"
                        }
                      },
                      _vm._l(_vm.is_ka_options, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否实力档口", prop: "is_strength" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否实力档口" },
                        model: {
                          value: _vm.form.is_strength,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_strength", $$v)
                          },
                          expression: "form.is_strength"
                        }
                      },
                      _vm._l(_vm.is_strength_options, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "重新代采计划全量生成",
                      prop: "all_rebuild_plan"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "重新代采计划全量生成" },
                        model: {
                          value: _vm.form.all_rebuild_plan,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "all_rebuild_plan", $$v)
                          },
                          expression: "form.all_rebuild_plan"
                        }
                      },
                      _vm._l(_vm.is_strength_options, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        "\n            开启后，无论是否有客需，都会根据“重采操作”在次日等量生成“重新代采计划”。\n          "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "前置仓入库时消除待开单数据",
                      prop: "is_auto_cancel_plan"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "前置仓入库时消除待开单数据" },
                        model: {
                          value: _vm.form.is_auto_cancel_plan,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_auto_cancel_plan", $$v)
                          },
                          expression: "form.is_auto_cancel_plan"
                        }
                      },
                      _vm._l(
                        [
                          { label: "否", value: "1" },
                          { label: "是", value: "2" }
                        ],
                        function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }
                      ),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        "\n            开启后，若前置仓入库时，采购计划中该sku待开单数将相应减少。\n          "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "退换货是否需接收", prop: "reject_accept" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "退换货是否需接收" },
                        model: {
                          value: _vm.form.reject_accept,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "reject_accept", $$v)
                          },
                          expression: "form.reject_accept"
                        }
                      },
                      _vm._l(_vm.is_strength_options, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        "\n            是—>退换货出库后需要完成次品接收才会生成退换货欠货。否—>退换货出库后直接生成退换货欠货。\n          "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否全款全上", prop: "is_strength" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否全款全上" },
                        model: {
                          value: _vm.form.is_full,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_full", $$v)
                          },
                          expression: "form.is_full"
                        }
                      },
                      _vm._l(_vm.is_strength_options, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否自主上款", prop: "is_self" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否自主上款" },
                        model: {
                          value: _vm.form.is_self,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_self", $$v)
                          },
                          expression: "form.is_self"
                        }
                      },
                      _vm._l(_vm.is_strength_options, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否轻入驻", prop: "is_lower_enter" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否轻入驻" },
                        model: {
                          value: _vm.form.is_lower_enter,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_lower_enter", $$v)
                          },
                          expression: "form.is_lower_enter"
                        }
                      },
                      _vm._l(_vm.is_lower_enter_options, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.form.is_lower_enter == 1
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "月目标", prop: "m_goal" } },
                      [
                        _c("el-input", {
                          attrs: { type: "number" },
                          model: {
                            value: _vm.form.m_goal,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "m_goal", $$v)
                            },
                            expression: "form.m_goal"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否开启直播", prop: "is_live" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否开启直播" },
                        model: {
                          value: _vm.form.is_live,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_live", $$v)
                          },
                          expression: "form.is_live"
                        }
                      },
                      _vm._l(_vm.is_live, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "是否开启截图上款",
                      prop: "is_screenshot_for_add_goods",
                      "label-width": "130px"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否开启截图上款" },
                        model: {
                          value: _vm.form.is_screenshot_for_add_goods,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "is_screenshot_for_add_goods",
                              $$v
                            )
                          },
                          expression: "form.is_screenshot_for_add_goods"
                        }
                      },
                      _vm._l(_vm.is_screenshot_for_add_goods, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { value: item.value, label: item.label }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "擅长季节", prop: "season" } },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        attrs: { lable: "擅长季节" },
                        model: {
                          value: _vm.form.season,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "season", $$v)
                          },
                          expression: "form.season"
                        }
                      },
                      [
                        _c("el-checkbox", { attrs: { label: "春季" } }),
                        _vm._v(" "),
                        _c("el-checkbox", { attrs: { label: "夏季" } }),
                        _vm._v(" "),
                        _c("el-checkbox", { attrs: { label: "秋季" } }),
                        _vm._v(" "),
                        _c("el-checkbox", { attrs: { label: "冬季" } })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "适合年龄阶段", prop: "season" } },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        model: {
                          value: _vm.form.age_group,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "age_group", $$v)
                          },
                          expression: "form.age_group"
                        }
                      },
                      _vm._l(_vm.resData.age_group, function(age) {
                        return _c(
                          "el-checkbox",
                          { key: age.key, attrs: { label: age.key } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(age.label) +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "档次", prop: "supply_grade" } },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        attrs: { lable: "档次" },
                        model: {
                          value: _vm.form.supply_grade,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "supply_grade", $$v)
                          },
                          expression: "form.supply_grade"
                        }
                      },
                      [
                        _c("el-checkbox", { attrs: { label: "低端" } }),
                        _vm._v(" "),
                        _c("el-checkbox", { attrs: { label: "中低" } }),
                        _vm._v(" "),
                        _c("el-checkbox", { attrs: { label: "中端" } }),
                        _vm._v(" "),
                        _c("el-checkbox", { attrs: { label: "中高" } }),
                        _vm._v(" "),
                        _c("el-checkbox", { attrs: { label: "高端" } })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "擅长品类" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        placeholder: "搜索品类",
                        options: _vm.resData.category,
                        props: { multiple: true },
                        filterable: ""
                      },
                      model: {
                        value: _vm.form.cat_ids,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cat_ids", $$v)
                        },
                        expression: "form.cat_ids"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "主要风格" } },
                  [
                    _c("el-transfer", {
                      attrs: {
                        filterable: "",
                        titles: ["选项", "选中"],
                        "filter-placeholder": "请输入风格",
                        data: _vm.styles_data
                      },
                      on: { change: _vm.build_second_styles },
                      model: {
                        value: _vm.form.styles,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "styles", $$v)
                        },
                        expression: "form.styles"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "副风格" } },
                  [
                    _c("el-transfer", {
                      attrs: {
                        filterable: "",
                        titles: ["选项", "选中"],
                        "filter-placeholder": "请输入风格",
                        data: _vm.second_styles_data
                      },
                      on: { change: _vm.build_styles },
                      model: {
                        value: _vm.form.second_styles,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "second_styles", $$v)
                        },
                        expression: "form.second_styles"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "一手店铺底图" } },
                  [
                    _c(
                      "el-col",
                      { style: "width:100%;", attrs: { span: 24 } },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "upload-demo",
                            staticStyle: {
                              display: "inline-block",
                              "margin-right": "10px"
                            },
                            style: "width:100px;float:left;height:50px;",
                            attrs: {
                              "show-file-list": false,
                              action: _vm.action,
                              multiple: "",
                              accept: "image/*",
                              "on-success": _vm.uploadSuccess1,
                              "on-remove": _vm.handleRemove,
                              "before-upload": _vm.beforeAvatarUpload,
                              "on-exceed": _vm.handleExceed,
                              "file-list": _vm.files,
                              "with-credentials": ""
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { margin: "10px 3px" },
                                attrs: { size: "small", type: "primary" }
                              },
                              [
                                _vm._v(
                                  "\n                上传图片\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.images1, function(item, index) {
                          return _vm.images1
                            ? _c(
                                "div",
                                {
                                  key: index,
                                  staticStyle: {
                                    float: "left",
                                    width: "50px",
                                    height: "50px",
                                    margin: "0 10px",
                                    border: "1px solid #ddd"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "50px",
                                          height: "50px"
                                        },
                                        attrs: { src: item },
                                        on: {
                                          click: function($event) {
                                            return _vm.previewImage(item)
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "15px",
                                            height: "15px",
                                            position: "absolute",
                                            top: "-5px",
                                            right: "-5px"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteImg1(item)
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "15px",
                                              height: "15px"
                                            },
                                            attrs: {
                                              src:
                                                _vm.origin +
                                                "/201804/13/15235857625ad012e238658.png"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "品牌logo" } },
                  [
                    _c(
                      "el-col",
                      { style: "width:100%;", attrs: { span: 24 } },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "upload-demo",
                            staticStyle: {
                              display: "inline-block",
                              "margin-right": "10px"
                            },
                            style: "width:100px;float:left;height:50px;",
                            attrs: {
                              "show-file-list": false,
                              action: _vm.action,
                              multiple: "",
                              accept: "image/*",
                              "on-success": _vm.uploadSuccess3,
                              "on-remove": _vm.handleRemove,
                              "before-upload": _vm.beforeAvatarUpload3,
                              "on-exceed": _vm.handleExceed3,
                              "file-list": _vm.files,
                              "with-credentials": ""
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { margin: "10px 3px" },
                                attrs: { size: "small", type: "primary" }
                              },
                              [
                                _vm._v(
                                  "\n                上传图片\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.images3, function(item, index) {
                          return _vm.images3
                            ? _c(
                                "div",
                                {
                                  key: index,
                                  staticStyle: {
                                    float: "left",
                                    width: "50px",
                                    height: "50px",
                                    margin: "0 10px",
                                    border: "1px solid #ddd"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "50px",
                                          height: "50px"
                                        },
                                        attrs: { src: item },
                                        on: {
                                          click: function($event) {
                                            return _vm.previewImage(item)
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "15px",
                                            height: "15px",
                                            position: "absolute",
                                            top: "-5px",
                                            right: "-5px"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteImg3(item)
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "15px",
                                              height: "15px"
                                            },
                                            attrs: {
                                              src:
                                                _vm.origin +
                                                "/201804/13/15235857625ad012e238658.png"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "营业执照" } },
                  [
                    _c(
                      "el-col",
                      { style: "width:100%;", attrs: { span: 24 } },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "upload-demo",
                            staticStyle: {
                              display: "inline-block",
                              "margin-right": "10px"
                            },
                            style: "width:100px;float:left;height:50px;",
                            attrs: {
                              "show-file-list": false,
                              action: _vm.action,
                              multiple: "",
                              accept: "image/*",
                              "on-success": _vm.uploadSuccess2,
                              "on-remove": _vm.handleRemove,
                              "before-upload": _vm.beforeAvatarUpload2,
                              "on-exceed": _vm.handleExceed2,
                              "file-list": _vm.files,
                              "with-credentials": ""
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { margin: "10px 3px" },
                                attrs: { size: "small", type: "primary" }
                              },
                              [
                                _vm._v(
                                  "\n                上传图片\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.images2, function(item, index) {
                          return _vm.images2
                            ? _c(
                                "div",
                                {
                                  key: index,
                                  staticStyle: {
                                    float: "left",
                                    width: "50px",
                                    height: "50px",
                                    margin: "0 10px",
                                    border: "1px solid #ddd"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "50px",
                                          height: "50px"
                                        },
                                        attrs: { src: item },
                                        on: {
                                          click: function($event) {
                                            return _vm.previewImage(item)
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "15px",
                                            height: "15px",
                                            position: "absolute",
                                            top: "-5px",
                                            right: "-5px"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteImg2(item)
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "15px",
                                              height: "15px"
                                            },
                                            attrs: {
                                              src:
                                                _vm.origin +
                                                "/201804/13/15235857625ad012e238658.png"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "推荐描述" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "40%", float: "left" },
                      attrs: { maxlength: "100" },
                      model: {
                        value: _vm.form.recommend_desc,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "recommend_desc", $$v)
                        },
                        expression: "form.recommend_desc"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v(
                        "\n            一手APP上的商家推荐描述（建议30字以内，否则在手机上超出的部分可能会变为省略号）\n          "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "买手说" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "40%", float: "left" },
                      attrs: { placeholder: "说点什么呢~" },
                      model: {
                        value: _vm.form.pg_say,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pg_say", $$v)
                        },
                        expression: "form.pg_say"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onSubmit }
                      },
                      [_vm._v(" 提交 ")]
                    )
                  ],
                  1
                )
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "el-row",
              {},
              [
                _c(
                  "el-dialog",
                  {
                    attrs: { visible: _vm.dialogVisible },
                    on: {
                      "update:visible": function($event) {
                        _vm.dialogVisible = $event
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "品牌信息",
                  visible: _vm.brandVisible,
                  width: "60%",
                  center: ""
                },
                on: {
                  "update:visible": function($event) {
                    _vm.brandVisible = $event
                  }
                }
              },
              [
                _c(
                  "el-form",
                  { attrs: { model: _vm.form } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "前端是否显示品牌名" } },
                      [
                        _c("el-switch", {
                          attrs: {
                            "inactive-color": "#ff4949",
                            "active-color": "#13ce66",
                            "inactive-value": "0",
                            "active-value": "1",
                            "inactive-text": "不显示",
                            "active-text": "显示"
                          },
                          model: {
                            value: _vm.form.is_show_brand,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "is_show_brand", $$v)
                            },
                            expression: "form.is_show_brand"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.form.brands, function(brand, index) {
                      return _c(
                        "el-form-item",
                        {
                          key: brand.key,
                          attrs: {
                            label: "品牌" + (index + 1),
                            prop: "brands." + index + ".value"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { display: "none" },
                            model: {
                              value: brand.key,
                              callback: function($$v) {
                                _vm.$set(brand, "key", $$v)
                              },
                              expression: "brand.key"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-input", {
                            staticStyle: { width: "70%", float: "left" },
                            attrs: { placeholder: "品牌名" },
                            model: {
                              value: brand.brand_name,
                              callback: function($$v) {
                                _vm.$set(brand, "brand_name", $$v)
                              },
                              expression: "brand.brand_name"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: {
                                label: index,
                                change: _vm.genSupplyName
                              },
                              model: {
                                value: _vm.form.is_main,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "is_main", $$v)
                                },
                                expression: "form.is_main"
                              }
                            },
                            [_vm._v("\n              主品牌\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.removeBrand(brand)
                                }
                              }
                            },
                            [_vm._v(" 删除 ")]
                          )
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c("el-button", { on: { click: _vm.addBrand } }, [
                      _vm._v(" 增加品牌 ")
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.brandVisible = false
                          }
                        }
                      },
                      [_vm._v(" 取 消 ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.setBrand }
                      },
                      [_vm._v(" 确 定 ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("el-row")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c_page-title" }, [
      _c("div", [_vm._v("新增商家")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d95ff98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d95ff98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supply/AddSupply.vue
// module id = null
// module chunks = 